import axios from "axios";
import soundManager from "../utils/SoundManager";

export const checkRunningTests = async () => {
    try {
        const csrfToken = localStorage.getItem("csrfToken");
        const serverUri = import.meta.env.VITE_APP_SERVER_URI;
        const apiVersion = import.meta.env.VITE_APP_TEST_SERVICE_API_VERSION;

        const response = await axios.get(`${serverUri}/${apiVersion}/tests/running`, {
            responseType: "json",
            withCredentials: true,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "X-CSRF-Token": csrfToken,
            },
        });

        const { noFailedTestNotReported, sounds } = response.data;

        if (Array.isArray(sounds)) {
            for (const sound of sounds) {
                if (sound) soundManager.play(sound); // sounds are queued in order
            }
        } else if (typeof sounds === "string") {
            soundManager.play(sounds);
        }

        return {
            isTestNotFailedAndNotReported: noFailedTestNotReported, sounds
        };
    } catch (error) {
        console.error("Error checking running tests:", error);
        return { isTestNotFailedAndNotReported: false, sounds: undefined };
    }
};
